import { NgModule } from '@angular/core';
import {CommonModule} from '@angular/common';

import {TextSearchPipe} from './text-search.pipe';
import { ReversePipe } from './reverse.pipe';
import { OrderByPipe } from './order-by.pipe';
import { KeysPipe } from './keys.pipe';

@NgModule({
  declarations:[TextSearchPipe, ReversePipe, OrderByPipe, KeysPipe],
  imports:[CommonModule],
  exports:[TextSearchPipe, ReversePipe, OrderByPipe, KeysPipe]
})

export class SharedPipes{}